import { deprecationContext } from './deprecationContext'

export const DeprecationContextProvider = deprecationContext.Provider

export { useDeprecation } from './useDeprecation'
export { useDeprecationContext } from './useDeprecationContext'
